import { useEffect } from 'react';

export default function useDashboardRowDrag(rowRef) {
  useEffect(() => {
    const row = rowRef.current;
    if (!row) return undefined;

    let drag = null;
    let suppressClick = false;
    let suppressTimer;

    const startDrag = (event) => {
      if (event.button !== 0 || row.scrollWidth <= row.clientWidth) return;
      drag = { startX: event.clientX, scrollLeft: row.scrollLeft, moved: false };
    };

    const moveDrag = (event) => {
      if (!drag) return;
      const distance = event.clientX - drag.startX;
      if (!drag.moved && Math.abs(distance) < 5) return;
      drag.moved = true;
      row.classList.add('dashboard-drag-row--dragging');
      row.scrollLeft = drag.scrollLeft - distance;
      event.preventDefault();
    };

    const endDrag = () => {
      if (!drag) return;
      row.classList.remove('dashboard-drag-row--dragging');
      if (drag.moved) {
        suppressClick = true;
        window.clearTimeout(suppressTimer);
        suppressTimer = window.setTimeout(() => { suppressClick = false; }, 0);
      }
      drag = null;
    };

    const preventDraggedClick = (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    };

    const preventNativeDrag = (event) => event.preventDefault();

    row.addEventListener('mousedown', startDrag);
    row.addEventListener('dragstart', preventNativeDrag);
    window.addEventListener('mousemove', moveDrag);
    window.addEventListener('mouseup', endDrag);
    row.addEventListener('click', preventDraggedClick, true);

    return () => {
      row.removeEventListener('mousedown', startDrag);
      row.removeEventListener('dragstart', preventNativeDrag);
      window.removeEventListener('mousemove', moveDrag);
      window.removeEventListener('mouseup', endDrag);
      row.removeEventListener('click', preventDraggedClick, true);
      window.clearTimeout(suppressTimer);
    };
  }, [rowRef]);
}
